// This file is generated by Sapper — do not edit it!
// webpack does not support export * as root_comp yet so do a two line import/export
import * as root_comp from '../../../routes/_layout.svelte';
export { root_comp };
export { default as ErrorComponent } from '../../../routes/_error.svelte';

export const ignore = [/^\/\.well-known\/apple-developer-merchantid-domain-association\/?$/, /^\/locales\/([^/]+?)\.json$/];

export const components = [
	{
		js: () => import("../../../routes/index.svelte")
	},
	{
		js: () => import("../../../routes/specials/paywall.svelte")
	},
	{
		js: () => import("../../../routes/library/index.svelte")
	},
	{
		js: () => import("../../../routes/library/[slug].svelte")
	},
	{
		js: () => import("../../../routes/profile/_layout.svelte")
	},
	{
		js: () => import("../../../routes/profile/deferred.svelte")
	},
	{
		js: () => import("../../../routes/profile/rented.svelte")
	},
	{
		js: () => import("../../../routes/genres/index.svelte")
	},
	{
		js: () => import("../../../routes/genres/[slug].svelte")
	},
	{
		js: () => import("../../../routes/search.svelte")
	},
	{
		js: () => import("../../../routes/todays/index.svelte")
	},
	{
		js: () => import("../../../routes/todays/preview/[slug].svelte")
	},
	{
		js: () => import("../../../routes/todays/[slug].svelte")
	},
	{
		js: () => import("../../../routes/books/index.svelte")
	},
	{
		js: () => import("../../../routes/books/[slug].svelte")
	},
	{
		js: () => import("../../../routes/legal.svelte")
	},
	{
		js: () => import("../../../routes/shop.svelte")
	}
];

export const routes = (d => [
	{
		// index.svelte
		pattern: /^\/$/,
		parts: [
			{ i: 0 }
		]
	},

	{
		// specials/paywall.svelte
		pattern: /^\/specials\/paywall\/?$/,
		parts: [
			null,
			{ i: 1 }
		]
	},

	{
		// library/index.svelte
		pattern: /^\/library\/?$/,
		parts: [
			{ i: 2 }
		]
	},

	{
		// library/[slug].svelte
		pattern: /^\/library\/([^/]+?)\/?$/,
		parts: [
			null,
			{ i: 3, params: match => ({ slug: d(match[1]) }) }
		]
	},

	{
		// profile/deferred.svelte
		pattern: /^\/profile\/deferred\/?$/,
		parts: [
			{ i: 4 },
			{ i: 5 }
		]
	},

	{
		// profile/rented.svelte
		pattern: /^\/profile\/rented\/?$/,
		parts: [
			{ i: 4 },
			{ i: 6 }
		]
	},

	{
		// genres/index.svelte
		pattern: /^\/genres\/?$/,
		parts: [
			{ i: 7 }
		]
	},

	{
		// genres/[slug].svelte
		pattern: /^\/genres\/([^/]+?)\/?$/,
		parts: [
			null,
			{ i: 8, params: match => ({ slug: d(match[1]) }) }
		]
	},

	{
		// search.svelte
		pattern: /^\/search\/?$/,
		parts: [
			{ i: 9 }
		]
	},

	{
		// todays/index.svelte
		pattern: /^\/todays\/?$/,
		parts: [
			{ i: 10 }
		]
	},

	{
		// todays/preview/[slug].svelte
		pattern: /^\/todays\/preview\/([^/]+?)\/?$/,
		parts: [
			null,
			null,
			{ i: 11, params: match => ({ slug: d(match[1]) }) }
		]
	},

	{
		// todays/[slug].svelte
		pattern: /^\/todays\/([^/]+?)\/?$/,
		parts: [
			null,
			{ i: 12, params: match => ({ slug: d(match[1]) }) }
		]
	},

	{
		// books/index.svelte
		pattern: /^\/books\/?$/,
		parts: [
			{ i: 13 }
		]
	},

	{
		// books/[slug].svelte
		pattern: /^\/books\/([^/]+?)\/?$/,
		parts: [
			null,
			{ i: 14, params: match => ({ slug: d(match[1]) }) }
		]
	},

	{
		// legal.svelte
		pattern: /^\/legal\/?$/,
		parts: [
			{ i: 15 }
		]
	},

	{
		// shop.svelte
		pattern: /^\/shop\/?$/,
		parts: [
			{ i: 16 }
		]
	}
])(decodeURIComponent);